module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mcl-wrapper"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Filtrar..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "input-group-addon glyphicon glyphicon-filter",
    staticStyle: {
      "top": "0"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('div', {
    staticClass: "mcl-items max-height",
    staticStyle: {
      "background-color": "white"
    }
  }, [(!_vm.isLoading) ? _c('span', _vm._l((_vm.displayed), function(item, i) {
    return _c('div', {
      staticClass: "checkbox text-left"
    }, [_c('label', {
      staticStyle: {
        "margin-left": "10px",
        "width": "95%"
      }
    }, [(_vm.additionalInfo && _vm.additionalInfo.left) ? _c('span', {
      staticClass: "left"
    }, [_vm._v(_vm._s(item[_vm.additionalInfo.left]))]) : _vm._e(), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected[item[_vm.idSelection]]),
        expression: "selected[item[idSelection]]"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.selected[item[_vm.idSelection]]) ? _vm._i(_vm.selected[item[_vm.idSelection]], null) > -1 : (_vm.selected[item[_vm.idSelection]])
      },
      on: {
        "click": function($event) {
          _vm.select(item[_vm.idSelection])
        },
        "change": function($event) {
          var $$a = _vm.selected[item[_vm.idSelection]],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.selected, item[_vm.idSelection], $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.selected, item[_vm.idSelection], $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.selected, item[_vm.idSelection], $$c)
          }
        }
      }
    }), _c('span', {
      staticStyle: {
        "color": "black"
      }
    }, [_vm._v(_vm._s(!_vm.parseField ? _vm.resolveObject(item) : _vm.parseField(_vm.resolveObject(item))))]), (_vm.additionalInfo && _vm.additionalInfo.right) ? _c('span', {
      staticClass: "right"
    }, [_vm._v(_vm._s(item[_vm.additionalInfo.right]))]) : _vm._e()])])
  })) : _vm._e(), (_vm.isLoading) ? _c('div', {
    staticClass: "checkbox text-left"
  }, [_c('label', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Carregando")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44fc4767"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=jade!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CheckList.vue
// module id = 316
// module chunks = 2